import type { LottieRefCurrentProps } from "lottie-react";

import * as React from "react";

import { cn } from "@replohq/lattice/utils/cn";
import loadingAnimation from "@v2/components/reploader.json";
import { useTheme } from "@v2/hooks/useTheme";
import Lottie from "lottie-react";
import { getWallClockLoopFrame } from "replo-utils/lib/loopFrame";

type Props = {
  visible?: boolean;
};

export function FullScreenLoader({ visible = true }: Props) {
  const lottieRef = React.useRef<LottieRefCurrentProps>(null);
  const { effectiveMode, palette } = useTheme();
  const isAuthRoute = window.location.pathname.startsWith("/auth");

  // eslint-disable-next-line replo/no-use-effect -- Legacy effect - may or may not be necessary
  React.useEffect(() => {
    if (visible) {
      // Several gates show this loader back to back; a shared clock keeps them one continuous loop.
      lottieRef.current?.goToAndPlay(
        getWallClockLoopFrame({
          frameRate: loadingAnimation.fr,
          frameCount: loadingAnimation.op - loadingAnimation.ip,
        }),
        true,
      );
    } else {
      lottieRef.current?.stop();
    }
  }, [visible]);

  return (
    <div
      className="position--center z-max fixed h-screen w-screen flex items-center justify-center"
      style={{
        visibility: visible ? "visible" : "hidden",
        // The auth screens sit on the Home canvas, like the onboarding steps they lead to.
        backgroundColor: isAuthRoute ? palette.homeCanvas : palette.sheet,
      }}
    >
      <Lottie
        lottieRef={lottieRef}
        animationData={loadingAnimation}
        loop={true}
        autoplay={false}
        className={cn("z-10 w-[200px]", effectiveMode === "dark" && "invert")}
      />
    </div>
  );
}
